import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useUser } from "../../../hooks/useUser";
import { sortPickerItems } from "../../../utils/sortPickerItems";

interface RequestorFilterProps {
  paramName?: "ordered_by" | "requested_by";
}

export function RequestorFilter({
  paramName = "ordered_by",
}: RequestorFilterProps) {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { details: userDetails } = useUser();

  const customerGroupId = params.customer_group_id;
  const { data = [], isLoading } = useClientPortalAPI(
    customerGroupId
      ? `/api/internal/client-portal/users/requestors/filtered/${customerGroupId}/`
      : "/api/internal/client-portal/users/requestors/"
  );

  return (
    <Picker
      isLoading={isLoading}
      showActionBar
      selectedKeys={params[paramName]?.split(",") || []}
      onSelectionChange={(keys) => setParam(paramName, Array.from(keys))}
      label={t("Requestor")}
      items={sortPickerItems({
        data,
        userDetails,
        includeAvatar: true,
        useIdAsKey: false,
        t,
      })}
      selectionMode="multiple"
      testID="case-requestor-filter"
    />
  );
}
